/** Cockpit → "Tonight's notes": read today's notes once before sleeping. */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, Moon } from 'lucide-react';
import { fetchTonight } from '@/lib/notes';

export function TonightNotesCard() {
  const navigate = useNavigate();
  const [t, setT] = useState(null);
  useEffect(() => { fetchTonight().then(setT).catch(() => setT(null)); }, []);
  if (!t) return null;
  return (
    <div className="rounded-3xl border border-indigo-100 bg-white p-4 sm:p-5" data-testid="cockpit-tonight-notes">
      <div className="flex items-center justify-between gap-2">
        <p className="font-heading text-[13px] font-semibold text-slate-800 flex items-center gap-1.5">
          <Moon className="w-4 h-4 text-indigo-500" /> Tonight's notes{t.count ? ` · ${t.count}` : ''}
        </p>
        {t.reviewed && <span className="text-[11px] font-heading text-emerald-600 flex items-center gap-1"><CheckCircle2 className="w-3.5 h-3.5" /> Read</span>}
      </div>
      <p className="font-body text-[13px] text-slate-500 mt-2">
        {t.count ? 'Go through the points you noted today once before you sleep — it locks them in.'
          : 'No notes today yet. Tap Take Note beside your Study Buddy while you chat.'}
      </p>
      <button onClick={() => navigate(t.count ? '/notes?tonight=1' : '/notes')} data-testid="cockpit-open-notes"
        className="mt-2.5 text-[11px] font-heading bg-indigo-600 text-white px-3 py-1 rounded-full">
        {t.count ? 'Read tonight\'s notes' : 'Open Notes Taken'}
      </button>
    </div>
  );
}

export default TonightNotesCard;
